import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import TagManager from 'react-gtm-module';
import { useFetchConfigQuery } from "../features/news-api-slice";
import Config from "../config";

const tagManagerArgs = {
    gtmId: Config.gtmId,
    events: {
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
    }
}

const Analytics = () => {
    const params = useParams();
    const { data, isFetching } = useFetchConfigQuery(params);

    const useAnalytics = useMemo(() => {
        if (!data) return false;
        if (params.seoUrl) return data.analytics.post;
        if (params.tag) return data.analytics.tag;
        if (params.category === 'press') return data.analytics.press;
        return data.analytics.index;
    }, [params, data]);

    useEffect(() => {
        if (!useAnalytics) return;

        TagManager.initialize(tagManagerArgs);
    }, [useAnalytics]);

    if (isFetching || !data || !useAnalytics) return null;

    return <Helmet>
    </Helmet>;
}

export default Analytics;
